import { makeStyles } from '@material-ui/core';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  container: {
    borderRadius: theme.sizes.roundCorners,
    backgroundColor: theme.colors.panel_background,
    overflow: 'hidden'
  },
  containerDark: {
    backgroundColor: theme.colors.card_background_secondary,
    paddingRight: 32,
    paddingLeft: 32,
    paddingTop: 24,
    paddingBottom: 32,
    ...reskinStyles(theme, theme.cardStyles.inset)
  },
  containerInner: {
    backgroundColor: theme.colors.card_primary_separator,
    paddingRight: 32,
    paddingLeft: 32,
    paddingTop: 24,
    paddingBottom: 24
  },
  addressFormField: {
    paddingBottom: 8
  }
});

export default makeStyles(styles);
